export enum BannerName {
  Top = 'top',
  TopDesktop = 'topDesktop',
  Card = 'card',
  Bottom = 'bottom',
  Background = 'background', // only Adriver
  BackgroundRight = 'background-right', // only AdManager
  BackgroundLeft = 'background-left', // only AdManager
  InListDesktop = 'inListDesktop',
  Catfish = 'catfish',
}
